
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes/freeze-dried-raw-chicken",
      function () {
        return require("private-next-pages/recipes/freeze-dried-raw-chicken.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipes/freeze-dried-raw-chicken"])
      });
    }
  